import { useMutation, useQuery } from 'react-query';
import listApi from '../apis/listAll';

const { fetchListAll } = listApi;
export const useGetListAll = (
  remark,
  pageNum,
  pageSize,
  requestType,
  onSuccess,
  onError
) =>
  useQuery(
    [
      '' + remark,
      pageNum,
      pageSize,
      requestType
    ],
    () =>
      fetchListAll(
        pageNum,
        pageSize,
        requestType
      ),
    {
      onSuccess,
      onError,
    }
  );
